<template>
  <div class="overflow-scroll-y" v-loading.fullscreen.lock="fullscreenLoading" :element-loading-text="loadingText">
    <div class="card-header">
      <h2>志望動機を入力</h2>
      <p v-if="$globalVar.isYagiPrime" style="white-space: pre-line">
        {{ reasonLabelYagiprime }}
      </p>
      <p v-else-if="formatId == 'rirekisho_job_change'" style="white-space: pre-line">
        {{ reasonLabel20250126 }}
      </p>
      <p v-else-if="formatId != 'rirekisho_job_change_old' ||
        formatId != 'rirekisho_job_change2' ||
        formatId != 'rirekisho_single' ||
        formatId != 'rirekisho_nophoto_double' ||
        formatId != 'rirekisho_nophoto'" style="white-space: pre-line">
        {{ reasonLabel20240717 }}
      </p>
      <p v-else style="white-space: pre-line">{{ reasonLabel }}</p>
    </div>

    <div class="add-item">
      <el-button v-if="formatId != 'rirekisho_esf_challenged'" @click="$modal.show('reason-dialog')"
        type="success">例文から追加</el-button>
      <!-- <el-button v-if="formatId != 'rirekisho_esf_challenged'" @click="showModalFromNewAi()"
        id="prime-reasonai-btn" type="danger">最新のAIを使う</el-button> -->
      <el-button @click="reasonClear()" icon="el-icon-delete" circle></el-button>
    </div>

    <div class="card-content">
      <modal name="reason-dialog" :adaptive="true" :scrollable="true" height="auto">
        <div class="v--modal-close-top">
          <el-button @click="$modal.hide('reason-dialog');" icon="el-icon-close" type="text"></el-button>
        </div>
        <div class="title">例文を選ぶ</div>
        <div class="description">
          <p>選択した例文が追加されます。</p>
          <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
        </div>
        <ul class="example-sentence">
          <li v-for="(item, index) in exampleSentences.reason"
            v-on:click="updateReason(item.replace(/<br>/ig, '\n')); $modal.hide('reason-dialog')" :key="index">
            <div class="title">{{ index }}</div>
            <div class="body" v-html="item"></div>
          </li>
        </ul>
        <div class="text-right">
          <el-button @click="$modal.hide('reason-dialog')">閉じる</el-button>
        </div>
      </modal>
      <modal name="ai-mypr-dialog" :adaptive="true" :scrollable="true" width="100%" height="auto" class="ai-mypr-modal">
        <div class="v--modal-close-top">
          <el-button @click="$modal.hide('ai-mypr-dialog');" icon="el-icon-circle-close-outline"
            style="font-size: 2rem; padding: 0;" type="text"></el-button>
        </div>
        <p
          style="display: inline-block; font-size: 0.7rem; font-weight: bold; color: #fff; background: #0F9934; border-radius: 15px; padding: 2px 10px; margin-bottom: 5px;">
          ヤギプライム機能</p>
        <div class="title">自分らしい文章に書き直そう</div>
        <div class="description">
          <p>4つの質問と記載の情報で、さらに文章があなたらしくなります。<br>
            ※例文選択・AI再生成すると、現在入力中の文章は上書きされますのでご注意ください。</p>
        </div>
        <div v-if="!aiResultView">
          <ul class="example-sentence">
            <li>
              <div class="title">※入力済みの履歴書内容
              </div>
              <div class="el-textarea">
                <div class="flex r-form-title">
                  <span>最終学歴</span>
                  <div class="el-textarea">
                    <el-input type="textarea" autosize placeholder="" title="あなたの趣味" autocomplete="off"
                      v-model="formatData.lastestEdu"></el-input>
                  </div>
                </div>
                <div class="flex r-form-title">
                  <span>最終職歴</span>
                  <div class="el-textarea">
                    <el-input type="textarea" autosize placeholder="" title="最終職歴" autocomplete="off"
                      v-model="formatData.lastestJob"></el-input>
                  </div>
                </div>
                <div class="flex r-form-title"><span>取得資格</span>
                  <div class="el-textarea">
                    {{ getLicences }}
                  </div>
                </div>
                <div class="flex r-form-title"><span>志望動機</span>
                  <div class="el-textarea">
                    {{ formatData.reason }}
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class=" title">Q.1 得意なこと
              </div>
              <div class="el-textarea">
                <div class="el-textarea"><el-input type="textarea" autosize placeholder="英語、プログラミング、コミュニケーション、Wordなど"
                    title="あなたの趣味" autocomplete="off" v-model="formatData.ai_strength"></el-input></div>
              </div>
            </li>
            <li>
              <div class="title">Q.2 希望企業名</div>
              <div class="el-textarea">
                <div class="el-textarea"><el-input type="textarea" autosize placeholder="株式会社Yagishなど" title="あなたの趣味"
                    autocomplete="off" v-model="formatData.ai_company_name"></el-input></div>
              </div>
            </li>
            <li>
              <div class="title">Q.3 希望業界</div>
              <div class="el-textarea">
                <div class="el-textarea"><el-select v-model="formatData.hopeIndustrycategory" placeholder="選択してください"
                    style="left:0;max-width: 100%;">
                    <el-option v-for="item in hopeIndustryOptions" style="width: 100%;" :key="item" :label="item"
                      :style="item" :value="item"></el-option>
                  </el-select></div>
              </div>
            </li>
            <li>
              <div class="title">Q.4 希望職種</div>
              <div class="el-textarea">
                <div class="el-textarea"><el-select v-model="formatData.hopeJobcategory" placeholder="選択してください"
                    style="left:0;max-width: 100%;">
                    <el-option v-for="item in hopeCareerJobcategoryOptions" style="width: 100%;" :key="item"
                      :label="item" :style="item" :value="item"></el-option>
                  </el-select></div>
              </div>
            </li>
          </ul>
          <div class="text-right" style="margin-top: 10px;" v-if="$globalVar.in_app_payments">
            <p style="font-size: 0.8rem;" v-if="$globalVar.isYagiPrime">
              <span>残り利用回数：</span><span>{{ aiUsageCount }}</span>
              <span v-if="$globalVar.isYagiPrime">（1日5回まで）</span>
            </p>
            <el-button @click="handleAIMypr"
              style="color: #fff; background-color: #e3165c; border-color: #e3165c; margin-bottom: 5px;">
              <span>{{ (!$firebase.isAuthenticated || !$globalVar.isYagiPrime) ? '🔒️ 続きを作成する' : '志望動機を作成する' }}</span>
            </el-button>
          </div>
        </div>
        <div v-else>
          <ul class="example-sentence">
            <li
              v-on:click="updateReason(aiResultMyprResult.replace(/<br>/ig, '\n')); $modal.hide('ai-mypr-dialog'); aiResultView = false">
              <div class="title">AIからの提案</div>
              <div class="body" v-html="aiResultMyprResult"></div>
            </li>
          </ul>
          <div v-if="!$globalVar.isYagiPrime" class="text-right" style="margin-top: 10px;">＼全文を作成する場合は／<br>
            <el-button @click="goYagiprimeRegister()" id="prime-reasonai-register-btn" v-if="$globalVar.in_app_payments"
              style="color: #fff; background-color: #e3165c; border-color: #e3165c;">ヤギプライム会員になる</el-button>
          </div>
        </div>
        <div class="text-right">
          <el-button v-if="$globalVar.isYagiPrime && aiResultView" type="primary"
            @click="toggleAIMyprDialog">もう一度作る</el-button>
          <el-button @click="$modal.hide('ai-mypr-dialog')">閉じる</el-button>
        </div>
      </modal>
      <el-input type="textarea" v-model="reason" :autosize="autosizeSettings"></el-input>
      <div class="button-container" v-if="$globalVar.in_app_payments">
        <button v-on:click="insertSentence" v-if="$firebase.isAuthenticated && isSendMail" class="primary-button">
          <span>メールの添削文章を挿入</span>
        </button>
        <button v-on:click="showModalFromNewAi" class="primary-button">
          <span>{{ (!$firebase.isAuthenticated || !$globalVar.isYagiPrime) ? '続きを作成する' : '自分らしい文章にする' }}</span></button>
        <button v-on:click="goYagiprimeAgent" class="secondary-button" v-if="$firebase.isAuthenticated">
          <span>文章を添削してもらう</span></button>
      </div>
      <div class="attention-limit character" v-if="previewErrors.reason">
        <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ReasonCard',
  components: {
  },
  props: {
    formatId: {
      type: String,
      required: true
    },
    exampleSentences: {
      type: Object,
      required: true
    },
    textareaMinRows: {
      type: Number,
      required: true
    },
    previewErrors: {
      type: Object,
      required: true
    },
    formatData: {
      type: Object,
      required: true
    },
    currentCardId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      aiResultView: false,
      aiResultMyprResult: '',
      aiResultReasonResult: '',
      fullscreenLoading: false,
      loadingText: 'AIがあなたに最適なテキストを生成しています',
      isFromYagiprimeAgent: false,
      hopeIndustryOptions: ['', 'IT・通信', 'ソフトウェア・情報処理', 'インターネット関連・ゲーム・アプリ関連', '機械・産業用装置・電機・OA機器', '自動車・自動車部品・輸送用機器', 'コンピュータ・通信機器・精密機器', '電子部品・半導体', '食品・飲料・たばこ・飼料', '化学・医薬・化粧品', '鉄鋼・非鉄金属・金属製品', '石油・石炭・ゴム・プラスチック', 'ガラス・セラミック・セメント', 'パルプ・紙・紙加工・印刷・印刷関連', '日用品・文具・オフィス用品', '建材・エクステリア', 'インテリア・住宅関連', 'アパレル・服飾関連', 'スポーツ・玩具・ゲーム機器', 'その他メーカー・製造関連', '電気・ガス・石油・水道', '放送（テレビ・ラジオ含む）', '新聞・出版', '広告', 'その他（芸能・エンタテインメント関連等）', '運輸（鉄道・航空・海運・物流等）', '総合商社', '専門商社', '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター', '通信販売、専門店・その他小売り', '銀行（協同組織金融含む）', '証券', '保険', 'その他金融（クレジット等）', 'リース・レンタル', 'ディベロッパー', '建設・建築設計・ハウスメーカー', '設備関連', 'プラント・プラントエンジニアリング', '不動産取引・不動産賃貸・不動産管理', 'デザイン・芸術関連', 'コンサルティング・マーケティング・調査', 'その他専門・技術サービス', 'ホテル・旅館', '外食', 'その他フード', '理美容・エステ・フィットネスクラブ', '旅行・観光', '家事サービス・クリーニング', '冠婚葬祭', 'その他生活関連サービス', 'アミューズメント・レジャーサービス', '教育関連', '医療・保育・介護、福祉', '環境・リサイクル・廃棄物処理', '整備・修理', '人材サービス', 'その他事業サービス（警備、コールセンター等）', 'その他'],
      hopeCareerJobcategoryOptions: ['', '営業', '事務・秘書・受付', '経理', '総務人事', 'バイヤー', '法務', '知的財産部門', '企画', 'マーケティング', '宣伝・広報', '経営企画', '経営コンサルタント', '為替ディーラー・トレーダー', '証券アナリスト', '融資・資産運用(ファンドマネージャー等）', 'ファイナンシャルアドバイザー', 'アクチュアリー', 'システムエンジニア・プログラマ', 'Webエンジニア', 'ネットワークエンジニア', 'セキュリティエンジニア', 'インフラ・データエンジニア', 'AIエンジニア', '組み込みエンジニア', 'カスタマーエンジニア', '社内SE・情シス', '研究職（製造系）', '設計開発', '生産・製造', '物流・在庫管理', 'セールスエンジニア', '品質管理', '医療技術', 'MR（医薬情報担当者）', '研究開発（医薬系）', '薬剤師', '栄養士', '福祉士・介護士・ホームヘルパー', '講師・インストラクター', '専門コンサルタント', '建築・土木設計', '施工管理', 'Webプロデューサー・ディレクター', 'Webデザイナー', 'デザイナー', 'ゲームクリエイター', 'ゲームプログラマ', 'データサイエンティスト・アナリスト', '記者・ライター', '編集・制作', '販売・接客', '店長（店舗経営・運営）', 'スーパーバイザー', '農業', '林業', '漁業'],
      reasonLabels: {
        default: '書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！',
        jobNew: '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
        jobNewSingle: '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
        reasonLabel20240717: 'いつも1時間かかる文章が、1分でできたらコスパ最強！？今すぐ最新のAIを使ってみよう！',
        reasonLabel20250126: 'あなたの入力した内容で志望動機を、AIで途中まで作成してみました。\n文章は編集することが可能です。',
        reasonLabelYagiprime: '最新のAIを使って、あなたらしい文章にするか、エージェントに文章を添削してもらおう！'
      },
      isSendMail: false,
      correctSentence: '',
      willInsertSentence: false,
      aiUsageCount: 0,
      showFromNewAi: false
    }
  },
  computed: {
    autosizeSettings () {
      let minRows
      if (window.innerWidth <= 768) {
        // rirekisho_job_change の場合は SP 時に最低6行、その他の場合は7行
        minRows = this.formatId === 'rirekisho_job_change' ? 7 : this.textareaMinRows
      } else {
        minRows = this.formatId === 'rirekisho_job_change' ? this.textareaMinRows + 1 : this.textareaMinRows
      }
      return { minRows, maxRows: 15 }
    },
    reason: {
      get () {
        return this.formatData.reason
      },
      set (value) {
        this.$emit('update:reason', value)
      }
    },
    getLicences: function () {
      let licensesStr = ''
      for (const key in this.formatData.licenseHistories) {
        licensesStr += this.formatData.licenseHistories[key].description + ','
      }
      return licensesStr
    },
    reasonLabel () {
      if (this.formatId === 'rirekisho_job_new') {
        return this.reasonLabels.jobNew
      } else if (this.formatId === 'rirekisho_job_new_single') {
        return this.reasonLabels.jobNewSingle
      }
      return this.reasonLabels.default
    },
    reasonLabel20240717 () {
      return this.reasonLabels.reasonLabel20240717
    },
    reasonLabel20250126 () {
      return this.reasonLabels.reasonLabel20250126
    },
    reasonLabelYagiprime () {
      return this.reasonLabels.reasonLabelYagiprime
    }
  },
  watch: {
    currentCardId: {
      handler (newVal) {
        if (newVal === 'reason' && !this.formatData.reason) {
          setTimeout(() => {
            this.getAIMyprAuto()
          }, 1000)
        }
      },
      immediate: true
    }
  },
  beforeMount () {
    this.$eventHub.$on('open-login-dialog', this.openLoginDialog)
    this.$eventHub.$on('payment_yagiprime_result', this.handlePaymentResult)
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed () {
    this.$eventHub.$off('open-login-dialog', this.openLoginDialog)
    this.$eventHub.$off('payment_yagiprime_result', this.handlePaymentResult)
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  },
  methods: {
    reasonClear () {
      this.formatData.reason = ''
      this.$message({
        message: '削除完了しました。',
        type: 'success'
      })
    },
    updateReason (text) {
      this.formatData.reason = text
    },
    getAIMyprAuto () {
      const app = this
      app.fullscreenLoading = true
      if (app.formatData.reason && app.formatData.reason.trim() !== '') {
        app.fullscreenLoading = false
      }
      if (app.fullscreenLoading) {
        if (app.$cookies.get('AutoReason')) {
          const autoReason = app.$cookies.get('AutoReason')
          let reason = ''
          if (!app.$firebase.isAuthenticated || !app.$globalVar.isYagiPrime) {
            reason = autoReason.substring(0, 100) + '...'
          } else {
            reason = autoReason
          }
          if (!app.formatData.reason || app.formatData.reason.trim() === '') {
            app.formatData.reason = reason
            app.$cookies.set('AutoReason', reason)
            app.$message({
              message: '自動で志望動機を取得しました',
              type: 'success'
            })
          }
          app.fullscreenLoading = false
          return
        }

        this.$axios
          .post(this.$varuna.endPoints.AIAutoReason, app.formatData, { timeout: 60000 })
          .then((response) => {
            if (response.data.success) {
              const responseMessage = response.data.message
              let reason = ''
              if (!app.$firebase.isAuthenticated || !app.$globalVar.isYagiPrime) {
                reason = responseMessage.substring(0, 100) + '...'
              } else {
                reason = responseMessage
              }
              if (!app.formatData.reason || app.formatData.reason.trim() === '') {
                app.formatData.reason = reason
                app.$cookies.set('AutoReason', reason)
                app.$message({
                  message: '自動で志望動機を取得しました',
                  type: 'success'
                })
              }
            }
          })
          .finally(() => {
            app.fullscreenLoading = false
          })
      }
    },
    handleAIMypr () {
      this.$yagiprimePaymentService.useFeature(this, 'self-introduction-shokumu', {
        onSuccess: () => {
          this.getAIMypr()
        }
      })
    },
    getAIMypr () {
      const app = this
      app.fullscreenLoading = true
      const formData = new FormData()

      if (app.$firebase && app.$firebase.isAuthenticated) {
        formData.append('uuid', app.$firebase.user.uid)
      }
      formData.append('education', app.formatData.lastestEdu || '')
      formData.append('job', app.formatData.lastestJob || '')
      formData.append('licenses', (app.formatData.licenseHistories && app.formatData.licenseHistories.map(l => l.description).join(',')) || '')
      formData.append('strength', app.formatData.ai_strength || '')
      formData.append('company_name', app.formatData.ai_company_name || '')
      formData.append('company_industry', app.formatData.hopeIndustrycategory || '')
      formData.append('company_job', app.formatData.hopeJobcategory || '')
      formData.append('reason', app.formatData.reason || '')

      this.$axios
        .post(this.$varuna.endPoints.aiIntroduceReason, formData, { timeout: 60000 })
        .then((response) => {
          if (response.data.success) {
            app.aiResultMyprResult = response.data.message
            app.aiResultView = true
            app.$message({
              message: '取得しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        })
        .catch((error) => {
          const errorMessage = error.response && error.response.data && error.response.data.message
          // 1日の上限に達しました。明日以降お試しください。
          app.aiResultView = false
          if (errorMessage === 'AIの使用回数が上限に達しました。') {
            app.$message({
              message: '1日の上限に達しました。明日以降お試しください。',
              type: 'error'
            })
          } else {
            app.$message({
              message: errorMessage || '失敗しました',
              type: 'error'
            })
          }
        })
        .finally(() => {
          app.fullscreenLoading = false
        })
    },
    getAIMyprContinue () {
      const app = this
      app.fullscreenLoading = true
      const formData = new FormData()

      if (app.$firebase && app.$firebase.isAuthenticated) {
        formData.append('uuid', app.$firebase.user.uid)
      }
      // formData.append('education', app.formatData.lastestEdu || '')
      // formData.append('job', app.formatData.lastestJob || '')
      // formData.append('licenses', (app.formatData.licenseHistories && app.formatData.licenseHistories.map(l => l.description).join(',')) || '')
      // formData.append('strength', app.formatData.ai_strength || '')
      // formData.append('company_name', app.formatData.ai_company_name || '')
      // formData.append('company_industry', app.formatData.hopeIndustrycategory || '')
      // formData.append('company_job', app.formatData.hopeJobcategory || '')
      // formData.append('reason', app.formatData.reason || '')
      // プロパティをdataにまとめる
      formData.append('data', '作成文章:短めの志望動機\n' +
        '学歴:' + (app.formatData.lastestEdu || '') + '\n' +
        '職歴:' + (app.formatData.lastestJob || '') + '\n' +
        '資格:' + ((app.formatData.licenseHistories && app.formatData.licenseHistories.map(l => l.description).join(',')) || '') + '\n' +
        '得意なこと:' + (app.formatData.ai_strength || '') + '\n' +
        '希望企業名:' + (app.formatData.ai_company_name || '') + '\n' +
        '希望業界:' + (app.formatData.hopeIndustrycategory || '') + '\n' +
        '希望職種:' + (app.formatData.hopeJobcategory || '') + '\n' +
        '志望動機:' + (app.formatData.reason || '') +
        '文章:' + (app.aiResultMyprResult.replace(/<br>/ig, '\n')))

      this.$axios
        .post(this.$varuna.endPoints.aiSentenseContinue, formData, { timeout: 60000 })
        .then((response) => {
          if (response.data.success) {
            app.aiResultMyprResult = response.data.message
            app.aiResultView = true
            app.$message({
              message: '取得しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        })
        .catch((error) => {
          const errorMessage = error.response && error.response.data && error.response.data.message
          // 1日の上限に達しました。明日以降お試しください。
          app.aiResultView = false
          if (errorMessage === 'AIの使用回数が上限に達しました。') {
            app.$message({
              message: '1日の上限に達しました。明日以降お試しください。',
              type: 'error'
            })
          } else {
            app.$message({
              message: errorMessage || '失敗しました',
              type: 'error'
            })
          }
        })
        .finally(() => {
          app.fullscreenLoading = false
        })
    },
    goYagiprimeRegister () {
      // this.$cookies.config(60 * 60 * 24, '')
      // const routeId = this.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      // this.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', routeId + '#self_introduction', null, null, 'yagish.jp')
      // this.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', routeId + '#self_introduction', null, null, 'localhost')
      // location.href = '/yagiprime_register'

      this.$yagiprimePaymentService.useFeature(this, 'self_introduction', {
        onSuccess: () => {
          this.getAIMyprContinue()
        },
        onCancel: () => {
          this.$modal.hide('ai-mypr-dialog')
          this.aiResultView = false
        }
      })
    },
    getAiUsageCount () {
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('category_type', 'reason')
      this.$axios.post(this.$varuna.endPoints.getAiUsageCount, formData).then((response) => {
        if (response.data.success) {
          if (this.$globalVar.isYagiPrime) {
            this.aiUsageCount = 5 - response.data.usage_count
          } else {
            this.aiUsageCount = 1 - response.data.usage_count
          }
        }
      })
    },
    showAiMyprDialog () {
      if (this.$firebase.isAuthenticated) {
        this.getAiUsageCount()
      } else {
        this.aiUsageCount = 1
      }

      this.isFromYagiprimeAgent = false
      if (!this.$firebase.isAuthenticated) {
        this.$eventHub.$emit('open-login-dialog')
        return
      }
      if (!this.$globalVar.isYagiPrime) {
        const routeId = this.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
        this.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', routeId + '#self_introduction', null, null, 'yagish.jp')
        this.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', routeId + '#self_introduction', null, null, 'localhost')
        this.$eventHub.$emit('show-yagiprime-payment-dialog', 'self_introduction')
        return
      }
      this.$modal.show('ai-mypr-dialog')
    },
    showModalFromNewAi () {
      this.showFromNewAi = true
      if (this.$firebase.isAuthenticated) {
        this.getAiUsageCount()
        this.$modal.show('ai-mypr-dialog')
      } else {
        this.aiUsageCount = 1
        this.$modal.show('ai-mypr-dialog')
      }
    },
    goYagiprimeAgent () {
      if (!this.$globalVar.isYagiPrime) {
        this.isFromYagiprimeAgent = true
        this.$eventHub.$emit('show-yagiprime-payment-dialog', 'yagiprime-agent')
        return
      }
      window.location.href = window.location.protocol + '//' + window.location.host + '/yagiprime/step1'
    },
    toggleAIMyprDialog () {
      this.aiResultView = false
    },
    authStateChanged () {
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      const app = this

      this.$axios
        .post(this.$varuna.endPoints.isSendCorrectionMail, formData, { timeout: 60000 })
        .then((response) => {
          app.isSendMail = response.data.success
          app.correctSentence = response.data.sentence
        })
    },
    insertSentence () {
      // もし、ヤギプライムでない場合は、課金ポップアップを表示
      this.willInsertSentence = true
      if (!this.$globalVar.isYagiPrime) {
        // LocalStorageを使用
        localStorage.setItem('correctSentence', this.correctSentence)

        this.$eventHub.$emit('open-yagiprime-payment-dialog')
        return
      }
      this.formatData.reason = this.correctSentence
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      this.$axios
        .post(this.$varuna.endPoints.insertedSentence, formData, { timeout: 60000 })

      this.$message({
        message: '追加しました',
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.overflow-scroll-y {
  overflow-y: auto;
}

.description {
  margin-bottom: 5px;
}

.r-form-title {
  align-items: center;
  margin-bottom: 5px;

  span {
    min-width: 81px;

    &:after {
      content: '：';
    }
  }
}

.card-header {
  padding: 1rem;

  h2 {
    margin: 0;
    font-size: 1.2rem;
  }
}

.card-content {
  padding: 1rem;
}

.attention {
  color: #f56c6c;
  font-size: 0.9rem;
}

.flex {
  display: flex;
}

.text-right {
  text-align: right;
}

.ai-mypr-modal {
  ::v-deep .v--modal {
    margin: 20px;
    width: auto !important;
    border-radius: 8px;
    padding: 20px;
  }
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 10px;

  // SP対応
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  button {
    width: 200px;
    padding: 10px 0;
    border-radius: 5px;
    font-weight: bold;
    display: block;

    &.primary-button {
      background: #8fbd67ff;
      color: rgb(255, 255, 255);
      border: none;
      margin-right: 10px;

      @media screen and (max-width: 768px) {
        margin-bottom: 10px;
        margin-right: 0;
      }
    }

    &.secondary-button {
      background: rgb(255, 255, 255);
      border: 1px solid #8fbd67ff;
      color: #8fbd67ff;
    }
  }
}
</style>
